<template>
  <div>
    <el-row :gutter="10" class="row-bg">
      <!-- 第一行：数据类型 / 单据类型 / 款项类型 -->
      <el-col :span="8" :xs="24">
        <el-form-item label="数据类型">
          <el-input model-value="供应商付款" disabled></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8" :xs="24">
        <el-form-item label="单据类型">
          <el-select v-model="paramsObj.documentType" placeholder="请选择单据类型" size="default" @change="fetch"
            multiple collapse-tags style="width:100%">
            <el-option v-for="item in documentTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="8" :xs="24">
        <el-form-item label="款项类型">
          <el-select v-model="paramsObj.feeType" placeholder="请选择款项类型" size="default" @change="fetch"
            multiple collapse-tags style="width:100%">
            <el-option v-for="item in feeTypes" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 第二行：关键词 / 公司 / 部门 / 时间范围 -->
      <el-col :span="5" :xs="24">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="paramsObj.keyword" placeholder="单据号/用途/收款方" @keyup.enter="fetch"
            clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col v-if="showOrgFilters" :span="7" :xs="24">
        <el-form-item label="申请公司">
          <el-tree-select ref="companys" v-model="paramsObj.companyId" :data="companys" @change="companyChange"
            check-strictly :render-after-expand="false" clearable placeholder="请选择公司" style="width:100%" />
        </el-form-item>
      </el-col>

      <el-col v-if="showOrgFilters" :span="5" :xs="24">
        <el-form-item label="申请部门">
          <el-tree-select ref="departments" v-model="paramsObj.departmentId" :data="departments" @change="fetch"
            check-strictly :render-after-expand="false" clearable placeholder="请选择部门" style="width:100%" />
        </el-form-item>
      </el-col>

      <el-col :span="7" :xs="24">
        <el-form-item label="时间范围">
          <el-date-picker v-model="valueTime" type="daterange" @calendar-change="fetch" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD"
            :shortcuts="$util.getShortCuts()" size="default" style="width:100%">
          </el-date-picker>
        </el-form-item>
      </el-col>

      <!-- 第三行：费用归属公司/部门(表单内选择) / 收款方 / 付款类型 -->
      <el-col v-if="showOrgFilters" :span="7" :xs="24">
        <el-form-item label="归属公司">
          <el-tree-select ref="feeCompanys" v-model="paramsObj.feeCompanyId" :data="companys" @change="feeCompanyChange"
            check-strictly :render-after-expand="false" clearable placeholder="费用归属公司(表单内选择)" style="width:100%" />
        </el-form-item>
      </el-col>

      <el-col v-if="showOrgFilters" :span="5" :xs="24">
        <el-form-item label="归属部门">
          <el-tree-select ref="feeDepartments" v-model="paramsObj.feeDepartmentId" :data="feeDepartments" @change="fetch"
            check-strictly :render-after-expand="false" clearable placeholder="费用归属部门" style="width:100%" />
        </el-form-item>
      </el-col>

      <el-col :span="5" :xs="24">
        <el-form-item label="收款方">
          <el-input v-model="paramsObj.payee" placeholder="供应商/收款方名称" @keyup.enter="fetch" clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="7" :xs="24">
        <el-form-item label="付款类型">
          <el-select v-model="paramsObj.paymentType" placeholder="请选择付款类型" size="default" @change="fetch"
            clearable style="width:100%">
            <el-option v-for="item in paymentTypes" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 第四行：申请人 / 确认 -->
      <el-col :span="5" :xs="24">
        <el-form-item label="申请人">
          <el-input v-model="paramsObj.applyUser" placeholder="申请人姓名" @keyup.enter="fetch" clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="7" :xs="24">
        <el-button size="default" type="primary" @click="fetch"> 确认 </el-button>
      </el-col>
    </el-row>

    <el-row type="flex" :gutter="20">
      <el-col :span="24" :xs="24">
        <h4 style="margin:10px auto; text-align: left;">周期内OA费用单据按收款方(供应商)汇总（点击行首箭头展开单据明细）</h4>
        <el-table class="table" :data="supplierData" border size="small" style="margin:0 auto">
          <el-table-column type="expand">
            <template #default="props">
              <div style="padding: 5px 40px;">
                <h4 style="margin:8px auto; text-align: left;">单据明细</h4>
                <el-table :data="getDetailRows(props.row.payee)" border size="small">
                  <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column>
                  <el-table-column prop="billCode" label="单据号" width="150" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="formName" label="业务类型" width="110" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="transferType" label="转账方式" width="80" align="center"> </el-table-column>
                  <el-table-column prop="billDate" label="日期" width="100" sortable align="center">
                    <template #default="scope">{{ $util.fmtDate(scope.row.billDate, "yyyy/MM/dd") }}</template>
                  </el-table-column>
                  <el-table-column prop="billStatus" label="单据状态" width="110" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="payStatus" label="付款状态" width="90" align="center">
                    <template #default="scope">
                      <el-tag :type="scope.row.payStatus === '已付款' ? 'success' : 'warning'" size="small">
                        {{ scope.row.payStatus }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="billFee" label="单据金额" width="110" sortable align="right">
                    <template #default="scope">{{ $util.fmtMoney(scope.row.billFee) }}</template>
                  </el-table-column>
                  <el-table-column prop="createUserName" label="申请人" width="90" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="companyName" label="申请公司" width="150" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="departmentName" label="申请部门" width="110" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="feeCompanyName" label="归属公司" width="150" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="feeDepartmentName" label="归属部门" show-overflow-tooltip> </el-table-column>
                </el-table>

                <h4 style="margin:8px auto; text-align: left;">月度付款金额</h4>
                <el-table :data="getMonthlyRows(props.row.payee)" border size="small" style="max-width: 400px;">
                  <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column>
                  <el-table-column prop="billMonth" label="月份" width="150" align="center">
                    <template #default="scope">{{ fmtMonth(scope.row.billMonth) }}</template>
                  </el-table-column>
                  <el-table-column prop="monthFee" label="月度付款金额" align="right">
                    <template #default="scope">{{ $util.fmtMoney(scope.row.monthFee) }}</template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column type="index" label="序号" align="center" width="55"> </el-table-column>
          <el-table-column prop="payee" label="供应商名称(收款方)" min-width="200" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="rankNo" label="排名" width="80" sortable align="center"> </el-table-column>
          <el-table-column prop="feeRate" label="占比" width="90" sortable align="center">
            <template #default="scope">{{ scope.row.feeRate }}%</template>
          </el-table-column>
          <el-table-column prop="billCount" label="单据数" width="90" sortable align="center"> </el-table-column>
          <el-table-column prop="totalFee" label="金额合计" width="130" sortable align="right">
            <template #default="scope">{{ $util.fmtMoney(scope.row.totalFee) }}</template>
          </el-table-column>
          <el-table-column prop="paidFee" label="已付款金额" width="130" sortable align="right">
            <template #default="scope">{{ $util.fmtMoney(scope.row.paidFee) }}</template>
          </el-table-column>
          <el-table-column prop="unpaidFee" label="未付款金额" width="130" sortable align="right">
            <template #default="scope">{{ $util.fmtMoney(scope.row.unpaidFee) }}</template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'ExpenseBillData',
  data() {
    // 默认时间范围（当月）必须在 data 阶段初始化：mounted 后再改 v-model 会触发 date-picker 自动弹框
    const range = this.$util.getCurrentDate('month');
    const fmt = (d) => d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    const hasRange = range && range.length === 2;
    const documentTypes = [
      { label: '请款单', value: 'payreceipt' },
      { label: '报销单', value: 'expense' }
    ];
    const feeTypes = [
      '货-工费（款到提货）',
      '货款-款到提货',
      '货-工费（货到付款)',
      '货-料（款到提货)',
      '货款-货到付款',
      '货款-预付款',
      '京润货款'
    ];
    const paymentTypes = ['采购付款', '费用报销', '薪酬付款', '其他付款'];
    return {
      valueTime: hasRange ? range : [],
      paramsObj: {
        keyword: '',
        companyId: '',
        departmentId: '',
        feeCompanyId: '',
        feeDepartmentId: '',
        payee: '',
        paymentType: '',
        documentType: documentTypes.map(item => item.value),
        feeType: [...feeTypes],
        applyUser: '',
        startDate: hasRange ? fmt(range[0]) : '',
        endDate: hasRange ? fmt(range[1]) + ' 23:59:59' : ''
      },
      documentTypes,
      feeTypes,
      paymentTypes,
      companyInitialized: false,
      companys: [],
      departments: [],
      feeDepartments: [],
      supplierData: [],
      detailData: [],
      monthlyData: []
    }
  },
  methods: {
    getDefaultCompanyId() {
      if (!this.showOrgFilters) return '*';
      const fromStore = (this.$store.getters.getUserInfo || {}).companyID;
      if (fromStore) return fromStore;
      try {
        const raw = sessionStorage.getItem('userInfo');
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed.companyID || '';
      } catch (e) {
        return '';
      }
    },
    companyChange() {
      this.paramsObj.departmentId = '';
      this.departments = [];
      if (this.paramsObj.companyId && this.paramsObj.companyId !== '*') {
        this.$kaung.departments(this.paramsObj.companyId).then(res => { this.departments = res; });
      }
      this.fetch();
    },
    feeCompanyChange() {
      // 费用归属公司(表单内选择)变化时重新加载归属部门，与申请部门列表互不干扰
      this.paramsObj.feeDepartmentId = '';
      this.feeDepartments = [];
      if (this.paramsObj.feeCompanyId) {
        this.$kaung.departments(this.paramsObj.feeCompanyId).then(res => { this.feeDepartments = res; });
      }
      this.fetch();
    },
    fetch() {
      if (!this.showOrgFilters) {
        this.paramsObj.companyId = '*';
      } else {
        if (!this.companys.length) this.$kaung.companys().then(res => { this.companys = res; });
        if (!this.companyInitialized) {
          this.paramsObj.companyId = this.getDefaultCompanyId();
          this.companyInitialized = true;
        }
      }
      if ((!this.valueTime || this.valueTime.length != 2) && (!this.paramsObj.startDate || !this.paramsObj.endDate)) {
        this.$message.warning('请选择时间范围');
        return;
      }
      if (this.valueTime && this.valueTime.length === 2) {
        this.paramsObj.startDate = this.formatTime(this.valueTime[0]);
        this.paramsObj.endDate = this.formatTime(this.valueTime[1]) + ' 23:59:59';
      }

      request({
        url: '/FundReport/ExpenseBillReport',
        method: 'get',
        paramsSerializer: { indexes: null },
        params: {
          keyword: this.paramsObj.keyword,
          CompanyID: this.paramsObj.companyId,
          DepartmentID: this.paramsObj.departmentId,
          FeeCompanyID: this.paramsObj.feeCompanyId,
          FeeDepartmentID: this.paramsObj.feeDepartmentId,
          Payee: this.paramsObj.payee,
          DocumentType: this.paramsObj.documentType,
          FeeType: this.paramsObj.feeType,
          PaymentType: this.paramsObj.paymentType,
          ApplyUser: this.paramsObj.applyUser,
          StartDate: this.paramsObj.startDate,
          EndDate: this.paramsObj.endDate
        }
      }).then((res) => {
        this.supplierData = res.data.supplierData || [];
        this.detailData = res.data.detailData || [];
        this.monthlyData = res.data.monthlyData || [];
      });
    },
    getDetailRows(payee) {
      return this.detailData.filter(item => item.payee === payee);
    },
    getMonthlyRows(payee) {
      return this.monthlyData.filter(item => item.payee === payee);
    },
    fmtMonth(month) {
      // yyyy-MM => yyyy年M月
      if (!month) return '';
      const parts = String(month).split('-');
      if (parts.length !== 2) return month;
      return parts[0] + '年' + Number(parts[1]) + '月';
    },
    formatTime(val) { return val.getFullYear() + "-" + (val.getMonth() + 1) + "-" + val.getDate(); }
  }
}
</script>

<style scoped>
.row-bg {
  margin-bottom: 10px;
}
</style>

<style lang="less" scoped>
.console-page {
  .el-row {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h4 {
    margin-top: 5px;
  }

  .row-bg {
    .el-col {
      padding: 2px 0;
    }

    padding: 10px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-date-editor {
    width: 100%;
    max-width: 280px;
  }

  .el-table th>.cell {
    padding: 0;
    color: #000;
  }

  .el-table .caret-wrapper {
    width: 12px;
    left: -5px;
  }
}
</style>
